import {
    CountryIso2,
    Locale,
} from '@shared/types/registration';

export const getLocaleByCountryCode = ({
    locale,
    iso2CountryCode,
}: {
    locale: string;
    iso2CountryCode: string;
}): string => (iso2CountryCode.toUpperCase() === CountryIso2.USA ? Locale.EnUs : locale);